import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LedgerAccount } from '@work4all/models/lib/Classes/LedgerAccount.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import { LedgerAccountTableQuickFilters } from '../ledger-account-table-components/ledger-account-table-filters/LedgerAccountTableQuickFilters';
import schema from '../schemata/ledgerAccount-table-schema.json';

const defaultSort = [{ field: 'name', direction: SortDirection.ASCENDING }];

export function LedgerAccountTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<LedgerAccount, Record<string, never>>({
    ...props,
    schema: schema as never,
    defaultSort,
    rowModifiers: (value) => {
      return {
        isFaded: value.disabled,
      };
    },
  });

  const { t } = useTranslation();

  const quickFilters = useMemo(
    () => <LedgerAccountTableQuickFilters table={dataTable.table} />,
    [dataTable.table]
  );

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      areas={{
        right: null,
        left: {
          content: quickFilters,
          resizable: true,
          collapsible: true,
          title: t('COMMON.FILTER'),
        },
      }}
      actions={{
        createWidget: false,
      }}
    />
  );
}
